
import stringify from 'qs/lib/stringify';

export default {
  name: 'AppPaginate',
  props: {
    series: { type: Array, required: true },
    currentPage: { type: Number, required: true },
    next: { type: Number, default: null }
  },
  created() {
    this.MAX_ADJACENT_PAGES_MOBILE = 3;
  },
  methods: {
    isSelected: page => typeof page === 'string',
    url(page) {
      return `?${stringify({ ...this.$route.query, page })}`;
    },
    click(event, page) {
      if (event.metaKey || event.ctrlKey) return;

      event.preventDefault();
      if (!isNaN(page) && !this.isSelected(page)) {
        this.$emit('click', page);
      }
    }
  }
};
